module.exports = __webpack_public_path__ + "static/media/safari.56492e17.jpg";